<template>
    <v-form ref="form_datos_generales">
        <v-container fluid grid-list-md>
            <v-row dense>
                <!-- <v-autocomplete label="Cliente *" color="textbox" v-model="objForm.idCliente" :items="listGeneral.listaClientes" :rules="requeridoRegla" @change="onListarDetalle" outline :readonly="_.size(listGeneral.listaClientes) == 1 ? true : false"/> -->
                <v-col cols="12" sm="4">
                    <v-text-field label="Tipo de Documento" color="textbox" v-model="objForm.tipoDocumento" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Cédula/Ruc" color="textbox" v-model="objForm.numDocumento" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Estado Civil" color="textbox" v-model="objForm.estadoCivil" disabled outlined dense />
                </v-col>
            </v-row>
            <v-row dense v-show="objModal.mostrarFormConyuge">
                <v-col cols="12" sm="12">
                    <span v-html="'Datos del Cónyuge'"></span>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field color="textbox" v-model="objForm.cedulaConyuge" label="Cedula *" disabled outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field color="textbox" v-model="objForm.nombreConyuge" label="Nombres y Apellidos *" disabled outlined dense />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Provincia" color="textbox" v-model="objForm.provincia" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Cantón" color="textbox" v-model="objForm.canton" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Fecha de Nacimiento" color="textbox" v-model="objForm.fechaNacimiento" disabled outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-text-field label="Dirección" color="textbox" v-model="objForm.domicilioCanton" disabled outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field color="textbox" v-model="objForm.celular" label="Teléfono Celular" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field color="textbox" v-model="objForm.telefono" label="Teléfono Domicilio" disabled outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field color="textbox" v-model="objForm.email" label="Email" disabled outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" v-show="showNext" class="text-right mt-3 mb-3">
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperDatoGeneralComponent',
        inject: ['next'],
        props:{
            showNext:{ type:Boolean, default:false },
            objForm:{ type:Object, default:{} },
            objModal:{ type:Object, default:{} },
            listGeneral:{ type:Object, default:{} },
            parametro:{ type:Object, default:{} },
        },
        data() {
            return {
                mostrarPaso: false,
            }
        },
        methods: {
            validar() {
                if (this.$refs.form_datos_generales.validate()) {
                    this.next('objDatosGen',this.objForm);
                }
            },
        },
    }
</script>